import { Cart, CartItem } from '@open-tender/types'
import { InvalidView, InvalidItemsView } from './CartErrors'

const CartCounts = ({ cart, errors }: { cart: Cart; errors: any[] }) => {
  const errorIndices = Object.keys(errors).map((i) => parseInt(i))
  const withErrors: (CartItem & { error?: any })[] = cart
    .map((i, index) => {
      return errorIndices.includes(index) ? { ...i, error: errors[index] } : i
    })
    .filter((i: CartItem & { error?: any }) => i.error)

  return (
    <InvalidView>
      <InvalidItemsView>
        <p>
          The quantities of the items below need to be adjusted before you can
          submit your order.
        </p>
        <ul>
          {withErrors.map((item, index) => (
            <li key={`${item.id}-${index}`}>
              <span>{item.name}</span>
              <span>{item.error}</span>
            </li>
          ))}
        </ul>
      </InvalidItemsView>
    </InvalidView>
  )
}

export default CartCounts
